import React from "react";
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  Stack,
  Chip,
  Snackbar,
  Alert,
} from "@mui/material";
import { api } from "../services/auth";

const Contact: React.FC = () => {
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (!email.includes("@")) {    
      setError("Please enter a valid email");
      setLoading(false);
      return;
  }
    if (message.length > 2000) {
      setError("Message too long (max 2000 characters)");
      setLoading(false);
      return;
    }

    if (message.trim().length < 10) {
      setError("Message too short (min 10 characters)");
      setLoading(false);
      return;
    }

    try {
      await api.post("/api/contact", { email, message });

      setSuccess(true);
      setEmail("");
      setMessage("");
    } catch (err) {
      console.error(err);
      setError("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Contact Us
        </Typography>

        <Stack direction="row" spacing={1}>
          <Chip label="Support" size="small" />
          <Chip label="Response: 24–48h" size="small" color="success" />
        </Stack>
      </Box>

      <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
        <CardContent>
          <Stack spacing={2}>

            <Typography color="text.secondary">
              Have questions, feedback, or need help? Send us a message.
            </Typography>

           <Box>
            <Typography variant="body2">
              📧 Use the contact form below
            </Typography>
          </Box>

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  label="Your Email"
                  value={email}
                  type="email"
                  autoComplete="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <TextField
                  fullWidth
                  label="Message"
                  multiline
                  rows={5}
                  value={message}
                  autoComplete="off"
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  helperText={`${message.length}/2000`}
                />

                <Button
                  variant="contained"
                  type="submit"
                  disabled={loading || !email || !message}
                  fullWidth
                  sx={{ py: 1.5 }}
                >
                  {loading ? "Sending..." : "Send Message"}
                </Button>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      {/* Success Snackbar */}
      <Snackbar
        open={success}
        autoHideDuration={4000}
        onClose={() => setSuccess(false)}
      >
        <Alert severity="success" variant="filled">
          Message sent successfully!
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={!!error}
        autoHideDuration={4000}
        onClose={() => setError(null)}
      >
        <Alert severity="error" variant="filled">
          {error}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default Contact;
